import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { classNames } from "@via/utils/helpers.tsx";
import { ComponentProps } from "react";
import { Control, useController } from "react-hook-form";
import { Tooltip } from "react-tooltip";

type TextAreaProps = ComponentProps<"textarea"> & {
  control: Control<any>;
  label?: string;
  name: string;
  validations?: any;
  className?: string;
  showRequiredField?: boolean;
  showTooltipIcon?: boolean;
  tooltipText?: string;
  rows?: number;
};

export default function FormTextAreaComponent({
  control,
  label,
  name,
  validations,
  className = "",
  showRequiredField = false,
  showTooltipIcon = false,
  tooltipText,
  rows = 3,
  ...textAreaProps
}: TextAreaProps) {
  const {
    field,
    fieldState: { error },
  } = useController({ control, name, rules: validations });

  return (
    <div className="mt-2 w-full">
      {label && (
        <label className="mb-2 flex items-center text-sm font-medium leading-6 text-gray-900">
          {label}
          {showRequiredField && <span className="text-red-400">&nbsp;*</span>}
          {showTooltipIcon && (
            <InformationCircleIcon
              id={`tooltip-${name}`}
              className="h-5 w-5 ml-1"
            />
          )}
        </label>
      )}
      {tooltipText && (
        <Tooltip anchorSelect={`#tooltip-${name}`}>
          <div>
            {tooltipText.split("<br/>").map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>
        </Tooltip>
      )}
      <textarea
        rows={rows}
        className={classNames(
          "block rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6",
          !className?.match(/\bw-\S+/) ? "w-full" : "", // add w-full only if no w-* present
          className
        )}
        {...field}
        {...textAreaProps}
      />
      {error && <span className="text-xs text-rose-500">{error.message}</span>}
    </div>
  );
}
